import { alpha } from '@mui/material/styles';

export const PROFILE_FORM_CARD_SX = {
  width: '100%',
  position: 'relative',
  bgcolor: 'background.default',
  boxShadow: (theme) =>
    `0 0 2px 0 ${alpha(theme.palette.grey[500], 0.12)}, 0 20px 40px -4px ${alpha(theme.palette.grey[500], 0.18)}`,
};

export const PROFILE_FORM_LOADING_BACKDROP_SX = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: (theme) => alpha(theme.palette.background.default, 0.72),
  zIndex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const PROFILE_FORM_ERROR_STICKY_SX = {
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backgroundColor: 'background.default',
  pt: { xs: 1, sm: 2 },
  pb: { xs: 1, sm: 2 },
  borderBottom: 1,
  borderColor: 'divider',
  marginBottom: { xs: 2, sm: 3 },
  mx: { xs: -1, sm: 0 },
};

export const PROFILE_FORM_NESTED_CARD_SX = {
  p: 2,
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  bgcolor: 'background.default',
  border: 1,
  borderColor: 'divider',
  boxShadow: 'none',
  '&:hover': {
    boxShadow: (theme) => theme.customShadows.z4,
  },
};

export const PROFILE_FORM_EMPTY_STATE_SX = {
  p: 3,
  textAlign: 'center',
  bgcolor: 'background.neutral',
  borderRadius: 1,
  border: '1px dashed',
  borderColor: 'divider',
};

export const PROFILE_FORM_EDITED_TEXT_SX = {
  color: 'text.disabled',
  fontSize: '14px',
  position: 'relative',
  top: '25%',
};
